import Link from "next/link";
import React, { useEffect, useState } from "react";
import moment from "moment"; // Import moment.js
import {getPledges, getTransactions} from "../../utils/api";
import {getAccountHolderId, getUserId} from "../../utils/jwtUtil";
import SiteConfig from "../../siteConfig";

const Positions = ({userId}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [accountHolderId, setAccountHolderId] = useState(null);
  const { data: pledgesData, error } = getPledges(accountHolderId);
  const [pledges, setPledges] = useState([]);
  const [filteredPledges, setFilteredPledges] = useState([]);

  useEffect(() => {
    setAccountHolderId(getAccountHolderId());
  }, []);
  
  useEffect(() => {
    if (pledgesData && Array.isArray(pledgesData)) {
      const sortedPledges = [...pledgesData].sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
      });
      setPledges(sortedPledges);
    }
  }, [pledgesData]);

  useEffect(() => {
    if (searchTerm.length >= 3) {
      const debounceTimeout = setTimeout(() => {
        const filtered = pledges.filter((pledge) =>
          pledge.pledgeId?.toLowerCase().startsWith(searchTerm.toLowerCase())
        );
        setFilteredPledges(filtered);
      }, 1000);
      return () => clearTimeout(debounceTimeout);
    } else {
      setFilteredPledges([]);
    }
  }, [searchTerm, pledges]);

  return (
    <div>
      {/* <!-- Search Box --> */}
      <div className="flex justify-center mb-16">
      <form
          className="relative ml-12 mr-8 hidden basis-3/12 lg:block"
        >
          <input
            type="search"
            className="text-jacarta-700 placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full rounded-2xl border py-[0.6875rem] px-4 pl-10 dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <span className="absolute left-0 top-0 flex h-full w-12 items-center justify-center rounded-2xl">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width={24}
              height={24}
              className="fill-jacarta-500 h-4 w-4 dark:fill-white"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z" />
            </svg>
          </span>
        </form>
      </div>

      {/* <!-- Positions --> */}
      <section className="relative pb-24">
        <div className="container">
          <div className="grid gap-7 md:grid-cols-3">
            {(filteredPledges.length > 0 ? filteredPledges : pledges).map((item) => {
              const { accountHolderId, pledgeId, claim, createdDateTime, created_at } = item;
              return (
                <div
                  key={pledgeId}
                  className="rounded-2.5xl border border-jacarta-100 bg-white p-12 text-center transition-shadow hover:shadow-xl dark:border-jacarta-600 dark:bg-jacarta-700"
                >
                  <h3 className="mb-1 font-display text-md-center text-jacarta-700 dark:text-white">
                    Pledge: {pledgeId}
                  </h3>
                  <span className="mb-4 block text-xs text-jacarta-400 dark:text-jacarta-300"> 
                    {moment(created_at).fromNow()} {/* Display relative date */}
                  </span> 
                  <p className="true-text mb-8 dark:text-jacarta-300">{claim}</p>
                  <Link 
                    target="_blank"
                    href={`${SiteConfig.PLEDGES_PDF_DOMAIN}/${pledgeId}.pdf`}
                    className="text-sm font-bold text-accent" 
                  > 
                    View Pledge
                  </Link> 
                </div>
              );
            })}
          </div>
        </div>
      </section>
      {/* <!-- end positions --> */}
    </div>
  );
};

export default Positions;
